import React, { useEffect, useState } from 'react';
import api from '../../../utils/api';
import BookingCard from './BookingCard';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmployeeBookings = ({ salonId }) => {
  const employeeName = (() => { try { return JSON.parse(atob(localStorage.getItem('token')?.split('.')[1] || ''))?.name || ''; } catch { return ''; } })();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchBookings = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await api.get(`/salons/${salonId}/bookings`);
      const received = Array.isArray(response.data) ? response.data : response.data?.bookings || [];
      const tokenPayload = JSON.parse(atob(localStorage.getItem('token')?.split('.')[1] || '{}'));
      const employeeId = tokenPayload.employeeId;
      // Defense in depth: never render another employee's booking even if an
      // older backend instance returns an unfiltered response.
      const ownBookings = employeeId
        ? received.filter((booking) => String(booking.employee?._id || booking.employee) === String(employeeId))
        : received;
      setBookings(ownBookings);
    } catch (err) {
      console.error('Error fetching employee bookings:', err);
      setError('خطا در دریافت رزروهای شما.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (salonId) fetchBookings(); }, [salonId]);

  if (loading) return <div className="flex justify-center py-12"><Icon name="Loader2" size={30} className="animate-spin text-primary" /></div>;
  if (error) return <div className="space-y-3 rounded-xl border border-error/20 bg-error/10 p-6 text-center text-error"><p>{error}</p><Button size="sm" variant="outline" onClick={fetchBookings}>تلاش مجدد</Button></div>;

  return (
    <div className="space-y-5" dir="rtl">
      <div className="flex items-center justify-between">
        <div><h1 className="text-2xl font-bold text-foreground">رزروهای {employeeName || 'من'}</h1><p className="mt-1 text-sm text-muted-foreground">فقط مشاهده رزروهای اختصاص‌یافته به شما</p></div>
        <Button variant="ghost" size="sm" iconName="RefreshCw" onClick={fetchBookings}>بروزرسانی</Button>
      </div>
      {bookings.length === 0 ? <div className="rounded-xl border border-border bg-card p-10 text-center text-muted-foreground">رزروی برای شما ثبت نشده است.</div> : <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">{bookings.map((booking) => <BookingCard key={booking._id} booking={booking} showActions={false} />)}</div>}
    </div>
  );
};

export default EmployeeBookings;
